import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings";
import {SectionDescription} from "components/misc/Typography";


const HeadingContainer = tw.div``
const Heading = tw(SectionHeading)`text-4xl `
const Subheading = tw(SubheadingBase)`text-center `
const Description = tw(SectionDescription)`mx-auto text-center`






export default ({
  heading = "",
  subheading = "",
  description = "Our team combines creativity with technical expertise to deliver outstanding solutions. Driven by passion, built on trust.",

}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading> }
          {description && <Description>{description}</Description> }
        </HeadingContainer>
    
      </ContentWithPaddingXl>
    </Container>
  );
};
